<!-- 告警中心 -->

<template>
  <div class="warn-container">
    <div class="warn-left common-bg">
      <div class="select-group">
        <div class="select">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="data-select">
          <el-date-picker
            v-model="selectDate"
            type="date"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            align="center"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <div class="input-search">
          <el-input
            placeholder="文字搜索"
            prefix-icon="el-icon-search"
            v-model="input1"
            clearable
            @clear="changeInput"
            @keyup.enter.native="changeInput"
          >
          </el-input>
        </div>
      </div>

      <div class="fire-fighting">
        <fire-fighting></fire-fighting>
      </div>
    </div>
    <div class="warn-right common-bg">
      <warn-num :count="alarmData"></warn-num>
    </div>
  </div>
</template>
<script>
import { getAlarmData } from "@/api";
import fireFighting from "./components/fire-fighting.vue";
import WarnNum from "./components/warn-num.vue";
import bus from "@/components/three-scene/Bus.js";
export default {
  data() {
    return {
      timer: null,
      options: [
        {
          value: "all",
          label: "全部模块",
        },
        {
          value: "GD",
          label: "供电系统",
        },
        {
          value: "XF",
          label: "消防",
        },
        {
          value: "AF",
          label: "安防",
        },
        {
          value: "KT",
          label: "空调",
        },
        {
          value: "DT",
          label: "电梯",
        },
        {
          value: "ZM",
          label: "照明",
        },
        {
          value: "CG",
          label: "车管",
        },
        {
          value: "JL",
          label: "计量",
        },
        {
          value: "HJ",
          label: "环境",
        },
        {
          value: "SB",
          label: "水泵",
        },
        {
          value: "WM",
          label: "水表",
        },
        {
          value: "WG",
          label: "网关",
        },
        {
          value: "PS",
          label: "排水",
        },
      ],
      value: "all",
      selectDate: "",
      input1: "",
      input2: "",
      alarmData: {},
    };
  },
  components: { fireFighting, WarnNum },
  mounted() {
    this.$store.state.threeEvent.intoWarnCenter = true;
    bus.emit("hiddenBuildSprite", false);
  },
  created() {
    this.getAlarmData();
    this.timer = setInterval(() => {
      this.getAlarmData();
    }, 30*60*1000);
  },
  methods: {
    changeInput(e) {
      this.input2 = this.input1;
    },
    async getAlarmData() {
      let { data: res } = await getAlarmData();
      this.alarmData = res;
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
.warn-container {
  pointer-events: all;
}
.warn-left {
  position: absolute;
  top: 135px;
  left: 99px;
  width: 840px;
  .select-group {
    display: flex;
    ::v-deep .el-input {
      width: 100%;
    }
    ::v-deep .el-input__inner {
      background-color: transparent;
      color: #c4c4c4;
    }
    ::v-deep .el-input__inner:focus {
      border-color: #fff;
    }
    ::v-deep .el-select {
      width: 100%;
    }
  }
  .select {
    width: 211px;
    height: 46px;
  }
  .data-select {
    width: 283px;
    height: 46px;
    margin-left: 24px;
  }
  .input-search {
    width: 296px;
    height: 46px;
    margin-left: 20px;
  }
  .fire-fighting {
    // margin-left: -10px;
    width: 100%;
    height: 844px;
  }
}
.warn-right {
  position: absolute;
  right: 42px;
  top: 135px;
  width: 416px;
}
</style>
<style lang="scss">
.popper__arrow {
  display: none !important;
}
.el-select-dropdown {
  backdrop-filter: blur(10px);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    radial-gradient(
      163.91% 118.33% at 50.24% 47.78%,
      rgba(241, 128, 47, 0.1) 0%,
      rgba(27, 154, 255, 0.1) 100%
    );
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  .el-select-dropdown__item {
    color: #c4c4c4;
  }
}
.el-select-dropdown__list {
  padding: 8px 0 !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.el-select-dropdown__item.selected {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.el-picker-panel {
  color: #efefef;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    radial-gradient(
      163.91% 118.33% at 50.24% 47.78%,
      rgba(241, 128, 47, 0.1) 0%,
      rgba(27, 154, 255, 0.1) 100%
    );
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  .popper__arrow {
    display: none;
  }
  .el-date-picker__header {
    background: rgba(191, 191, 191, 0.2);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    margin: 0;
    padding: 12px;
    .el-picker-panel__icon-btn {
      color: #afafaf;
    }
    .el-date-picker__header-label {
      color: #efefef;
    }
  }
  .el-picker-panel__content {
    margin-top: 0px;
    .el-date-table th {
      color: #efefef;
    }
    .el-date-table td.next-month,
    .el-date-table td.prev-month {
      color: #c4c4c4;
    }
    .el-date-table td span {
      border-radius: 0;
    }
    .el-date-table td.current:not(.disabled) span {
      background-color: rgba(255, 255, 255, 0.13);
    }
  }
}
</style>
